import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.messageHistoryList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.messageHistoryList.error;
export const messageHistoryListDataResponse = (state: RootState) =>
  state.messageHistoryList.messageHistoryListResponse;
